/* eslint-disable */
const getters = {
  getData(state) {
    return state.data;
  },
  getIsLoaded(state) {
    return state.isLoaded;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
